export const apiBasePath = (_lang: string) => '/api/v1';
export const baseUrl = '/';
